import { Box, Typography, Stack, debounce } from '@mui/material';
import LoaderComponent from 'components/Loader';
import ReactECharts from 'echarts-for-react';
import { useEffect, useRef, useState } from 'react';

type GuageWidgetProps = {
	color?: string;
	isLoading: boolean;
	title: any;
	data?: any | null;
	minTitleHeight?: `${number}px`;
	sectorLabel?: string;
};

const defaultOptions = {
	backgroundColor: '#F3F6FA',
	series: [
		{
			type: 'gauge',
			center: ['50%', '45%'],
			min: 0,
			max: 0,
			splitNumber: 5,
			itemStyle: {
				color: '#e5e5e5'
			},
			progress: {
				show: false
			},
			pointer: {
				show: false
			}
		}
	]
};

const GuageWidget = ({
	color = '#1b1e35',
	isLoading = false,
	title = '',
	minTitleHeight = '38px',
	data = null,
	sectorLabel = '',
}: Readonly<GuageWidgetProps>) => {
	const chartRef = useRef<any>(null);
	const [windowSize, setWindowSize] = useState(window.innerWidth);

	useEffect(() => {
			// re-render chart to fix alignment when resizing the browser
			const handleResize = debounce(() => {
				if (chartRef.current) {
					setWindowSize(window.innerWidth);
				}
			}, 200);
	
			handleResize();
			window.addEventListener('resize', handleResize);
			return () => {
				window.removeEventListener('resize', handleResize);
			};
		}, []);

	return (
		<Box display="flex" flexGrow={1} height="100%" position="relative" flexDirection="column" bgcolor="#ffffff" borderRadius="5px">
			{/* Header with title and sector label */}
			<Stack direction="row" p={2} justifyContent="space-between" alignItems="start" minHeight={minTitleHeight}>
				<Stack direction="row">
					<Typography variant="widgetTitle" sx={{ color: '#000000' }}>{title}</Typography>
				</Stack>
				{sectorLabel !== '' && (
					<Box
						bgcolor="#ffffff"
						sx={{
							borderRadius: '16px',
							width: 'auto',
							display: 'flex',
							alignItems: 'center',
							padding: '5px',
						}}
					>
						<Typography variant="bodyText" sx={{ textAlign: 'center', color: '#000000' }}>
							{sectorLabel}
						</Typography>
					</Box>
				)}
				</Stack>
				<Box flexGrow={1}>
					{!isLoading ? (
						<ReactECharts
							key={windowSize}
							ref={chartRef}
							option={data && Object.keys(data) ? data : defaultOptions}
							theme={{
								backgroundColor: { color }
							}}
						/>
					) : (
						<LoaderComponent />
					)}
				</Box>
		</Box>
	);
};

export default GuageWidget;
